// extracted by mini-css-extract-plugin
module.exports = {"close":"e462cbfa4b--close--xkh6d"};